<template>
  <v-dialog
    :model-value="modelValue"
    width="800"
    @update:model-value="onDialogVisibility"
    @click:outside="closeModal"
  >
    <v-card rounded="lg">
      <div class="bg-red-600 relative">
        <i
          class="mdi mdi-close text-xl cursor-pointer text-white absolute top-2 right-3"
          @click="closeModal"
        ></i>
        <h2 class="text-xl font-semibold text-white py-5 pl-10">
          BAST Garansi IMKP
        </h2>
      </div>

      <div class="px-10 py-5">
        <div v-if="loading" class="py-10 text-center text-gray-500">
          Memuat data BAST Garansi…
        </div>

        <template v-else>
          <div class="mb-4">
            <p class="text-xs font-semibold text-gray-500 mb-1">Judul Proyek</p>
            <p class="text-sm font-medium text-gray-800">
              {{ judulProyek || "-" }}
            </p>
          </div>

          <div class="text-sm mb-4 font-medium">
            <span>File saat ini :</span>
            <ul v-if="fileGaransi.length > 0" class="mt-1">
              <li v-for="(file, index) in fileGaransi" :key="index">
                <a
                  class="text-red-600 font-normal cursor-pointer"
                  style="text-decoration: none"
                  @click="downloadFile(file, formatFilename)"
                >
                  File BAST Garansi_{{ index + 1 }}.pdf
                </a>
              </li>
            </ul>
            <p v-else class="text-red-600 mt-1">-</p>
          </div>

          <div v-if="fileGaransi.length > 0" class="text-sm mb-4">
            <p class="font-medium mb-1">Catatan</p>
            <v-textarea
              v-if="isEditable"
              v-model="catatan"
              variant="outlined"
              density="compact"
              color="#475569"
              rows="6"
              hide-details="auto"
              placeholder="Masukkan catatan"
            />
            <div v-else style="white-space: pre-line" class="text-gray-700">
              {{ catatan || "-" }}
            </div>
          </div>

          <div class="flex justify-end gap-2">
            <template v-if="fileGaransi.length > 0 && isEditable">
              <FormButton
                label="Tolak"
                classes="bg-red-600 text-white capitalize"
                @click="askConfirm('rejected')"
              />
              <FormButton
                label="Setuju"
                classes="bg-green-600 text-white capitalize"
                @click="askConfirm('approved')"
              />
            </template>
            <FormButton
              v-else
              label="Tutup"
              variant="outlined"
              classes="capitalize text-gray-500"
              @click="closeModal"
            />
          </div>
        </template>
      </div>
    </v-card>
  </v-dialog>

  <ConfirmModal
    v-model="dialogConfirm"
    img="warning.png"
    title="BAST Garansi IMKP"
    :description="confirmDescription"
    wording-cancel="Batal"
    wording-confirm="Ya"
    :loading="submitting"
    @close-modal="dialogConfirm = false"
    @confirm-data="submitGaransi"
  />
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
import FormButton from "@/components/FormButton.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import axios from "axios";
import {
  API_BASE_URL,
  CMS_IMKP_DETAIL,
  CMS_SET_BAST_WARRANTY_ADMIN,
} from "@/constants";
import { statusIMKPEnum } from "@/utilities/enum";
import { downloadFile } from "@/utilities/globalFunction";
import util from "@/assets/js/util";

const url_imkp_detail = API_BASE_URL + CMS_IMKP_DETAIL;
const url_imkp_bast_garansi = API_BASE_URL + CMS_SET_BAST_WARRANTY_ADMIN;

export default {
  name: "ApprovalBastWarrantyImkpModal",
  mixins: [GlobalDataMixin],
  components: {
    FormButton,
    ConfirmModal,
  },
  emits: ["update:modelValue", "submitted"],
  props: {
    modelValue: { type: Boolean, default: false },
    imkpId: { type: [Number, String], default: null },
    kontraktorId: { type: [Number, String], default: null },
    status: { type: [Number, String], default: null },
    judulProyek: { type: String, default: "" },
    namaKontraktor: { type: String, default: "" },
    usecase: { type: String, default: "" },
  },
  data() {
    return {
      statusIMKPEnum,
      loading: false,
      submitting: false,
      dialogConfirm: false,
      pendingAction: null,
      fileGaransi: [],
      catatan: "",
      formatFilename: "",
    };
  },
  computed: {
    isEditable() {
      return this.status === statusIMKPEnum.BAST_WARRANTY;
    },
    confirmDescription() {
      const label =
        this.pendingAction === "approved" ? "persetujuan" : "penolakan";
      return `Apakah anda yakin akan melakukan ${label} BAST Garansi IMKP ini?`;
    },
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.resetForm();
        this.fetchDetail();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    downloadFile,
    resetForm() {
      this.fileGaransi = [];
      this.catatan = "";
      this.formatFilename = "";
      this.pendingAction = null;
      this.dialogConfirm = false;
    },
    async fetchDetail() {
      if (!this.imkpId) return;
      try {
        this.loading = true;
        const result = await axios.get(url_imkp_detail, {
          params: { id: this.imkpId },
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });
        const res = result.data.data[0];

        this.fileGaransi = res.fileBastWarranty
          ? JSON.parse(res.fileBastWarranty)
          : [];
        this.formatFilename =
          "File BAST Garansi " + this.judulProyek + "-" + this.namaKontraktor;

        if (this.status === statusIMKPEnum.IMKP_DONE) {
          this.catatan = res.catatanWarranty;
        }
      } catch (error) {
        util.showError("Terjadi kesalahan saat memuat data BAST Garansi.");
      } finally {
        this.loading = false;
      }
    },
    askConfirm(action) {
      if (this.submitting) return;
      this.pendingAction = action;
      this.dialogConfirm = true;
    },
    async submitGaransi() {
      try {
        this.submitting = true;
        const bodyJson = {
          id: this.imkpId,
          usecase: this.usecase,
          kontraktorId: this.kontraktorId,
          catatanWarranty: this.catatan?.trim(),
          action: this.pendingAction,
        };

        await axios.post(url_imkp_bast_garansi, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });

        util.showInfo("BAST Garansi IMKP berhasil di tindaklanjuti!", 2000);
        this.dialogConfirm = false;
        this.$emit("submitted");
        this.closeModal();
      } catch (error) {
        util.showError(
          "Terjadi kesalahan saat menindaklanjuti BAST Garansi IMKP!",
        );
      } finally {
        this.submitting = false;
      }
    },
    closeModal() {
      this.onDialogVisibility(false);
    },
    onDialogVisibility(open) {
      this.$emit("update:modelValue", open);
    },
  },
};
</script>
